module.exports = __webpack_public_path__ + "static/img/icon-video.9b5ba951.svg";